function getDateOnly(value) {
  return String(value || "").split(" ")[0];
}

function getPaymentDelayDays(invoice) {
  const dueDate = getDateOnly(invoice?.invoice_date_due);
  const paymentDate = getDateOnly(invoice?.x_payment_date);
  if (!dueDate || !paymentDate) return null;

  const due = new Date(`${dueDate}T00:00:00`);
  const paid = new Date(`${paymentDate}T00:00:00`);
  if (Number.isNaN(due.getTime()) || Number.isNaN(paid.getTime())) return null;

  const diffMs = paid.getTime() - due.getTime();
  return Math.round(diffMs / (1000 * 60 * 60 * 24));
}

function getDelayLabel(days) {
  if (typeof days !== "number") return "-";
  if (days > 0) return `${days} days late`;
  if (days < 0) return `${Math.abs(days)} days early`;
  return "On time";
}

function getDelayClassName(days) {
  return typeof days === "number" && days > 0
    ? "text-red-600 dark:text-red-500"
    : "";
}

const CustomerInvoicesView = ({ invoices = [] }) => {
  if (invoices.length === 0) {
    return <div className="opacity-70">No invoices found.</div>;
  }

  return (
    <div className="-mx-2 text-sm">
      <table className="with-line">
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Due Date</th>
            <th>Payment Date</th>
            <th className="text-right">Payment Time</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice) => {
            const delayDays = getPaymentDelayDays(invoice);
            return (
              <tr key={invoice.id}>
                <td className="whitespace-nowrap">
                  {invoice.display_name || "-"}
                </td>
                <td className="whitespace-nowrap">
                  {getDateOnly(invoice.invoice_date_due) || "-"}
                </td>
                <td className="whitespace-nowrap">
                  {getDateOnly(invoice.x_payment_date) || "-"}
                </td>
                <td
                  className={`text-right whitespace-nowrap ${getDelayClassName(delayDays)}`}
                >
                  {getDelayLabel(delayDays)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerInvoicesView;
